import { useAuth } from "@/components/context/useAuth";
import { Navigate } from "react-router-dom";
import { DriverOrders } from "./components/DriverOrders";
import { PastOrders } from "./components/PastOrders";
import { getCompletedOrders } from "@/api/profile";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Box, Tab, Tabs, Toolbar } from "@mui/material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`orders-tabpanel-${index}`}
            aria-labelledby={`orders-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export const DriverOrdersDashboard = () => {
    const { user } = useAuth();
    const [tabValue, setTabValue] = useState(0);

    const { data: completedOrdersData } = useQuery({
        queryKey: ["completed-orders-count"],
        queryFn: () => getCompletedOrders(1, 1, {}),
    });

    const hasCompletedOrders = (completedOrdersData?.total ?? 0) > 0;

    if (!user?.is_driver && !user?.is_admin) {
        return <Navigate to="/" />;
    }

    const handleTabChange = (
        _event: React.SyntheticEvent,
        newValue: number
    ) => {
        setTabValue(newValue);
    };

    if (!hasCompletedOrders) {
        return <DriverOrders />;
    }

    return (
        <Box
            sx={{
                backgroundColor: "#F4F7FE",
                minHeight: "100vh",
                width: "100%",
            }}
        >
            <Toolbar sx={{ display: { sm: "none" } }} />
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2, pt: 2 }}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="driver orders tabs"
                >
                    <Tab
                        label="My Orders"
                        id="orders-tab-0"
                        aria-controls="orders-tabpanel-0"
                    />
                    <Tab
                        label="Past Orders"
                        id="orders-tab-1"
                        aria-controls="orders-tabpanel-1"
                    />
                </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
                <DriverOrders />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <PastOrders />
            </TabPanel>
        </Box>
    );
};

export default DriverOrdersDashboard;
